export const DEFAULT_BASE_URL = "https://salazar.redacto.tech";

export const PATHS = {
  submit: "/webhook/dpdpa/generate",
  status: "/webhook/dpdpa/status",
} as const;

export const DEFAULT_POLL_INTERVAL_MS = 3000;
export const DEFAULT_POLL_TIMEOUT_MS = 300_000;
export const MAX_CONSECUTIVE_ERRORS = 3;
export const REQUEST_TIMEOUT_MS = 15_000;

export const STORAGE_KEY = "redacto_dpdpa_lead";

export const DEFAULT_LOGO_URL = "https://cdn.redacto.io/assets/redacto-logo.svg";

export const DEFAULT_BRAND = {
  name: "Redacto",
  primaryColor: "#4262ff",
  accentColor: "#a259ff",
  textColor: "#050038",
  borderColor: "#e5e5e5",
  backgroundColor: "#f7f7f7",
  borderRadius: "8px",
  fontFamily: "inherit",
} as const;

export const SUCCESS_COLOR = "#a6c03d";
export const ERROR_COLOR = "#f24e1e";

export const NAME_MIN_LENGTH = 2;
export const NAME_MAX_LENGTH = 120;

export const DOMAIN_REGEX =
  /^(?!-)[a-z0-9-]{1,63}(?<!-)(\.[a-z0-9-]{1,63})+$/i;

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const FREEMAIL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.co.in",
  "yahoo.co.uk",
  "hotmail.com",
  "outlook.com",
  "live.com",
  "icloud.com",
  "me.com",
  "aol.com",
  "proton.me",
  "protonmail.com",
  "mail.com",
  "gmx.com",
  "zoho.com",
  "rediffmail.com",
]);
